export const cdrOutcomes=['ANSWERED','NO ANSWER','BUSY','FAILED','CONGESTION'];
export const historyKey=call=>call.history_id||call.id;
export const finishedHistory=rows=>rows.filter(call=>Number.isFinite(call.ended)&&call.ended>0).map(call=>recordingBlocked(call)?{...call,recordings:[]}:call);
export const recordingBlocked=call=>call.recording_eligible===false||(call.cdr_verified&&cdrOutcomes.includes(call.cdr_disposition)&&call.cdr_disposition!=='ANSWERED');
export function agentTalkSeconds(call){
 if(call.cdr_verified!==false&&cdrOutcomes.includes(call.cdr_disposition)&&call.cdr_disposition!=='ANSWERED')return 0;
 if(Object.hasOwn(call,'agent_talk_seconds'))return call.agent_talk_seconds;
 return String(call.cdr_application||'').toLowerCase()==='dial'?call.billsec:null;
}
export function cdrDisposition(call){
 const value=String(call.cdr_disposition||'').trim().toUpperCase();
 return call.cdr_verified!==false&&cdrOutcomes.includes(value)?value:'Pending CDR';
}
export function recordingRows(call,records){
 if(recordingBlocked(call))return [];
 return call.cdr_verified?records.filter(record=>record.id===call.cdr_recording_id||record.history_ids?.includes(historyKey(call))):records;
}
